import React from "react";
import { Helmet } from "react-helmet";
import { ArrowRight } from "lucide-react";
import blogPushImage from "../media/blog_push380.png";
import "./Blogs.css";

const blogPosts = [
  {
    slug: "/blog/radiology-viewer",
    title: "Building a Cloud-Based Radiology Viewer for Healthcare Providers",
    excerpt:
      "How we built a HIPAA-compliant, cloud-native DICOM viewer on AWS, reducing image load times by 70% and enabling remote diagnostics across 12 locations.",
    date: "March 2024",
    tag: "Healthcare",
    image: null,
  },
  {
    slug: "/blog/agricultural-app",
    title: "Smart Agriculture: Building a Cloud Platform for Precision Farming",
    excerpt:
      "A cloud-based precision agriculture platform with IoT sensors, satellite imagery, and ML models that helped a 15,000-acre operation increase yield by 25%.",
    date: "January 2024",
    tag: "Agriculture",
    image: null,
  },
  {
    slug: "/blog/push-ads",
    title: "Understanding Push Ads: Their Mechanics and Impact",
    excerpt:
      "A comprehensive guide to push advertising: how push ads work, types of push notifications, pricing models, and tips for effective campaigns.",
    date: "November 2023",
    tag: "Marketing",
    image: blogPushImage,
  },
  {
    slug: "/blog/aws-dicom",
    title: "Scalable DICOM Imaging with AWS Serverless for Healthcare",
    excerpt:
      "Case study: AWS Serverless solutions for processing large volumes of DICOM medical images, reducing processing time by 50% with full HIPAA compliance.",
    date: "July 2023",
    tag: "Case Study",
    image: null,
  },
];

function MainBlog() {
  return (
    <>
      <Helmet>
        <title>Blog - Cloud Development, Healthcare IT & AgriTech Insights | Com2Cloud</title>
        <meta
          name="description"
          content="Read Com2Cloud's latest insights on cloud development, healthcare IT, precision agriculture, and digital marketing. Case studies, technical deep dives, and industry analysis."
        />
        <meta
          name="keywords"
          content="cloud development blog, AWS case studies, healthcare IT, precision agriculture, push ads, DICOM imaging, Com2Cloud blog"
        />
        <link rel="canonical" href="https://com2cloud.com/blog" />
      </Helmet>
      <div className="blog-index">
        <div className="blog-index-hero">
          <h1>Blog</h1>
          <p>Insights on cloud development, healthcare IT, and digital marketing</p>
        </div>

        <div className="blog-index-grid">
          {blogPosts.map((post) => (
            <a key={post.slug} href={post.slug} className="blog-index-card">
              {post.image ? (
                <img
                  src={post.image}
                  alt={post.title}
                  className="blog-index-card-image"
                />
              ) : (
                <div
                  className="blog-index-card-image"
                  style={{ background: "var(--gradient-brand)" }}
                />
              )}
              <div className="blog-index-card-body">
                <div className="blog-index-card-meta">
                  <span className="blog-index-card-tag">{post.tag}</span>
                  <span className="blog-index-card-date">{post.date}</span>
                </div>
                <div className="blog-index-card-title">{post.title}</div>
                <div className="blog-index-card-excerpt">{post.excerpt}</div>
                <span className="blog-index-card-link">
                  Read more <ArrowRight size={14} />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </>
  );
}

export default MainBlog;
